import './public-path'
import Vue from 'vue'
import './utils/initAppInfo'
import i18nLangLoader from '@/locale/i18n'
// import app from './App'
// import router from '@hotelcem/router/index'
// import store from '@hotelcem/store/index'
import * as filters from '@/filters/index'
import * as echarts from 'echarts'
import * as AppBaseConfigService from '@/storage/services/AppBaseConfigService'

// qiankun
import MicroActions from '@/qiankun/qiankun-actions.js'

import './registerServiceWorker'

// 性能监控
// import '../registerAegis'

// 全局时间监听
import './utils/events'

import '@/styles/voc-ui/index.scss'

import VocUI from 'vocust-ui'

Vue.prototype.$echarts = echarts

Vue.use(VocUI)

Vue.config.productionTip = false

/* Vue.config.errorHandler = function (err, vm, info) {
  // if (window.__aegis) {
  //   window.__aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`)
  // }
  console.error(`Error: ${err?.toString()}\nStack: ${err.stack}\nInfo: ${info}`)
} */

Vue.config.ignoredElements = ['trans']
Vue.config.warnHandler = function (err, vm, trace) {
  if (err.includes('__UNDEF')) {
    // 忽略 i18n导致的告警
    return
  }
  console.error(err, trace)
}

// 配置应用基础信息 Start
AppBaseConfigService.updateAppBaseConfig({
  appId: 'Basic Y2VtX212cDpjZW1fbXZwX3NlY3JldA==',
  appName: 'hotelcem',
})
/* Register global filters */
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

let appInstance = null
function render(props = {}) {
  if (window.__POWERED_BY_QIANKUN__) {
    if (props) {
      // 注入 actions 实例
      MicroActions.setActions(props)
    }
  }

  // 配置应用基础信息 End
  i18nLangLoader.then(lang => {
    //必须放这里加载，否则会导致js中直接变量无法翻译
    const app = require('./App').default
    const router = require('@hotelcem/router/index').default
    const store = require('@hotelcem/store/index').default
    appInstance = new Vue({
      router,
      store,
      render: h => h(app),
    }).$mount('#app')

    // 隐藏子应用菜单
    store.commit('common/setHideChildMenu', props?.hideChildMenu)
    store.commit('common/setIsJms', props?.isJms)

    // 将当前的 Vue 根实例绑定到 window 对象上
    if (window && !window.__XM_HOTEL_CEM_VUE_INSTANCE) {
      window.__XM_HOTEL_CEM_VUE_INSTANCE = appInstance
    }
    if (process.env.NODE_ENV === 'development') {
      // vue-devtools  加入此处代码即可
      Vue.config.devtools = true // 开启devtools
      const instanceDiv = document.createElement('div')
      instanceDiv.__vue__ = appInstance
      document.body.appendChild(instanceDiv)
      if ('__VUE_DEVTOOLS_GLOBAL_HOOK__' in window) {
        window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = Vue
      }
    }
  })
}

// 独立运行微应用时
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {
  console.log('[vue] vue app bootstraped')
}

// 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
export async function mount(props) {
  console.log('[vue] props from main framework', props)
  render(props)
}
// unmount时销毁应用, 防止内存泄漏
export async function unmount() {
  appInstance.$destroy()
  appInstance.$el.innerHTML = ''
  appInstance = null
}
